<template>
  <div class="of_header">
    <div class="logo">
      <img src="../assets/images/logo.png" alt="logo">
    </div>
    <div class="navbar">
      <a-menu v-model="current" mode="horizontal">
        <a-menu-item key="index">
          <router-link to="/index">{{$t('lang.header_index')}}</router-link>
        </a-menu-item>
        <a-sub-menu  name="3">
          <span slot="title" class="submenu-title-wrapper">
            <a>{{$t('lang.header_about')}}</a>
            <a-icon type="down"/>
          </span>
          <a-menu-item key="project">
            <router-link to="/project">{{$t('lang.header_project')}}</router-link>
          </a-menu-item>
          <a-menu-item key="friend">
            <router-link to="/friend">{{$t('lang.header_friend')}}</router-link>
          </a-menu-item>
          <!-- <a-menu-item key="people">
            <router-link to="/people">{{$t('lang .header_people')}}</router-link>
          </a-menu-item> -->
        </a-sub-menu>
        <a-menu-item key="news" v-if="this.$i18n.locale === 'zh-CN' ">
          <router-link to="/news">{{$t('lang.header_news')}}</router-link>
        </a-menu-item>
        <a-menu-item key="ceo">
          <router-link to="/ceo">{{$t('lang.header_memo')}}</router-link>
        </a-menu-item>
      </a-menu>
      <div class="lang" v-on:click="changeLang">
        <a>{{$t('lang.header_lang')}}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: [""]
    };
  },
  methods: {
    changeLang: function() {
      console.log("1");
      if (this.$i18n.locale === "zh-CN") {
        this.$i18n.locale = "en-US";
      } else {
        this.$i18n.locale = "zh-CN";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.of_header {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  padding: 0 80px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 16px rgba(194, 194, 194, 0.16);
  @media screen and (max-width: 768px) {
    padding: 0 10px;
  }
  .logo {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    img {
      width: 149px;
      height: 48px;
      line-height: 100px;
    }
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .navbar {
    display: flex;
    display: -webkit-flex;
    .ant-menu-horizontal {
      border: none;
    }
    .lang {
      a {
        font-size: 18px;
        line-height: 85px;
        color: rgba(0, 0, 0, 0.65);
        @media screen and (max-width: 768px) {
          font-size: 16px;
          line-height: 55px;
        }
      }
    }
  }
  .ant-menu {
    .ant-menu-item {
      padding: 0 30px;
      @media screen and (max-width: 768px) {
        padding: 0 10px;
      }
    }
    .ant-menu-item,
    .ant-menu-submenu {
      line-height: 80px;
      @media screen and (max-width: 768px) {
        line-height: 50px;
      }
      a {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.65);
        @media screen and (max-width: 768px) {
          font-size: 16px;
        }
      }
    }
    .ant-menu-submenu-selected{
      a{
        color: #1890ff;
      }
    }
    .ant-menu-submenu {
      span {
        font-size: 18px;
        vertical-align: middle;
        @media screen and (max-width: 768px) {
          font-size: 16px;
        }
      }
      .ant-menu-submenu-title {
        .submenu-title-wrapper {
          .anticon {
            margin-right: 0;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
